/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_In_Reason_Return_From_Packaging_ProcessInputs */

const vi_pkl_in_reason_return_from_packaging_process = /** @type {(inputs: Pkl_In_Reason_Return_From_Packaging_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trả từ quy trình đóng gói`)
};

/**

* @param {Pkl_In_Reason_Return_From_Packaging_ProcessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_in_reason_return_from_packaging_process = /** @type {((inputs?: Pkl_In_Reason_Return_From_Packaging_ProcessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_In_Reason_Return_From_Packaging_ProcessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_in_reason_return_from_packaging_process(inputs)
});